import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class FamilyService {
    static async update(id, data, subpropertyId) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation FAMILY_UPDATE(
          $id: String!
          $data: FamilyInput!
          $subpropertyId: String!
        ) {
          familyUpdate(
            id: $id, 
            data: $data,
            subpropertyId: $subpropertyId
            ) {
            id
          }
        }
      `,

            variables: {
                id,
                data,
                subpropertyId
            },
        });

        return response.data.familyUpdate;
    }

    static async destroyAll(ids, subpropertyId) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation FAMILY_DESTROY(
          $ids: [String!]!
          $subpropertyId: String!
          ) {
          familyDestroy(
            ids: $ids,
            subpropertyId: $subpropertyId
          )
        }
      `,

            variables: {
                ids,
                subpropertyId
            },
        });

        return response.data.familyDestroy;
    }

    static async create(data, subpropertyId) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation FAMILY_CREATE(
          $data: FamilyInput!
          $subpropertyId: FamilyInput!
          ) {
          familyCreate(
            data: $data,
            subpropertyId: $subpropertyId
            ) {
            id
          }
        }
      `,

            variables: {
                data,
                subpropertyId
            },
        });

        return response.data.familyCreate;
    }

    static async import (values, importHash, subpropertyId) {
        const response = await graphqlClient.mutate({
            mutation: gql `
        mutation FAMILY_IMPORT(
          $data: FamilyInput!
          $importHash: String!
          $subpropertyId: String!
        ) {
          familyImport(
            data: $data, 
            importHash: $importHash,
            subpropertyId: $subpropertyId
            )
        }
      `,

            variables: {
                data: values,
                importHash,
                subpropertyId
            },
        });

        return response.data.familyImport;
    }

    static async find(id, subpropertyId) {
        const response = await graphqlClient.query({
            query: gql `
        query FAMILY_FIND(
          $id: String!
          $subpropertyId: String!
          ) {
          familyFind(
            id: $id,
            subpropertyId: $subpropertyId
            ) {
            id
            name
            createdAt
            updatedAt
          }
        }
      `,

            variables: {
                id,
                subpropertyId,
            },
        });

        return response.data.familyFind;
    }

    static async list(filter, orderBy, limit, offset, subpropertyId) {
        const response = await graphqlClient.query({
            query: gql `
        query FAMILY_LIST(
          $filter: FamilyFilterInput
          $orderBy: FamilyOrderByEnum
          $limit: Int
          $offset: Int
          $subpropertyId: String!
        ) {
          familyList(
            filter: $filter,
            orderBy: $orderBy,
            limit: $limit,
            offset: $offset,
            subpropertyId: $subpropertyId
          ) {
            count
            rows {
              id
              name
              updatedAt
              createdAt
            }
          }
        }
      `,

            variables: {
                filter,
                orderBy,
                limit,
                offset,
                subpropertyId,
            },
        });

        return response.data.familyList;
    }

    static async listAutocomplete(query, limit, subpropertyId) {
        const response = await graphqlClient.query({
            query: gql `
        query FAMILY_AUTOCOMPLETE(
          $query: String
          $limit: Int
          $subpropertyId: Int
        ) {
          familyAutocomplete(
            query: $query, 
            limit: $limit
            subpropertyId: $subpropertyId
            ) {
            id
            label
          }
        }
      `,

            variables: {
                query,
                limit,
                subpropertyId
            },
        });

        return response.data.familyAutocomplete;
    }
}